<template>
  <v-card :id="`scope-${scope}`" row wrap class="nx-form-scope-card" :class="{ collapsed }">
    <v-card-actions @click="onClick">
      <v-icon
        color="nx-primary--darken-2"
        :class="{'has-error': errors.length, 'has-warning': warnings.length}"
        v-if="icon"
        v-text="icon"
      />
      <h3 class="nx-form-scope-card__title" v-text="title" />
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <v-btn slot="activator" icon v-if="collapsable" class="nx-form-scope-card__collapse">
          <v-icon color="primary" v-text="collapsed ? 'expand_more' : 'expand_less'" />
        </v-btn>
        <span>{{ collapsed ? $t('message.bag.actions.show') : $t('message.bag.actions.hide') }}</span>
      </v-tooltip>
    </v-card-actions>
    <v-slide-y-transition>
      <v-flex class="nx-form-scope-card__contents" xs12 v-show="!collapsed">
        <slot />
      </v-flex>
    </v-slide-y-transition>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import throttle from 'lodash/throttle';

export default {
  name: 'nx-form-scope-card',
  props: {
    scope: {
      type: String,
    },
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
    collapsable: {
      type: Boolean,
    },
    startsCollapsed: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    warnings: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      collapsed: this.startsCollapsed,
      lastScrollTop: 0,
    };
  },
  computed: {
    ...mapGetters([
      'features',
    ]),
  },
  created() {
    this.throttleScroll = throttle(this.elementInViewport, 50);
    window.addEventListener('scroll', this.throttleScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.throttleScroll);
  },
  methods: {
    onClick() {
      if (!this.collapsable) {
        return;
      }

      this.collapsed = !this.collapsed;
      this.$emit('collapse', this.collapsed);
    },
    elementInViewport() {
      const el = document.getElementById(`scope-${this.scope}`);
      if (!el) {
        return;
      }
      const rect = el.getBoundingClientRect();
      if (rect.bottom >= 250 && rect.top <= window.innerHeight) {
        this.$emit('visible', this.scope);
      } else {
        this.$emit('invisible', this.scope);
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '../../../assets/stylus/variables.styl';

.v-card__actions {
  padding-left: 20px;
  cursor: pointer;
}

.nx-form-scope-card {
  margin-bottom: 6px;

  &__title {
    margin-left: 20px;
    font-family: Roboto;
    font-size: 17px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.41;
    letter-spacing: normal;
    text-transform: uppercase;
  }

  &__collapse {
    padding: 0;
    margin: 0 -6px 0 0;
  }

  &__contents {
     padding: 0 20px 10px;
  }
}

i.v-icon.has-error::after {
  content: "\2022";
  color: red;
  position: absolute;
  top: 4px;
  left: 35px;
  text-shadow: -2px 0 white, 0 2px white, 2px 0 white, 0 -2px white;
}
i.v-icon.has-warning::after {
  content: "\2022";
  color: gold;
  position: absolute;
  top: 4px;
  left: 35px;
  text-shadow: -2px 0 white, 0 2px white, 2px 0 white, 0 -2px white;
}
</style>
